module.exports = __webpack_public_path__ + "static/p06_cencerro-8ba68306bc516341c9062e396eb570de.png";